<div class="col-lg-12 mb-3">
  <div class="row child">
    <p-card class="card-spacing-0">
      <!-- <span class="d-flex justify-content-between align-items-center m-3">
        <span class="col-auto">
          <h2 class="mb-0" *ngIf="showHeading">BC Ledger</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn"> </span>
      </span> -->

      <div class="adduser-container-hgt p-3">
        <div class="row">
          <ng-container *ngIf="isFromBCLedger || !isBAC">
            <div
              class="col-3 fixed-width mb-2"
              *ngIf="showBrandingConsultantDropDown">
              <div class="form-group has-float-label">
                <label
                  class="form-label"
                  for="bcSelectedId"
                  *ngIf="!fromManagerView"
                  >Branding Consultant
                  <span class="madatory-field">*</span></label
                >
                <label class="form-label" for="Manager" *ngIf="fromManagerView"
                  >Managers <span class="madatory-field">*</span></label
                >
                <p-select
                  [(ngModel)]="bcSelectedId"
                  (onChange)="bcSelected()"
                  [disabled]="disableDropDown"
                  [options]="bcList"
                  [filter]="true"
                  [showClear]="true"
                  [filterBy]="'firstName,lastName,personnelNumber'"
                  [emptyFilterMessage]="'No records found'"
                  optionValue="personnelNumber"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="35">
                  <ng-template pTemplate="selectedItem" let-selectedOption>
                    {{
                      (selectedOption?.firstName || "") +
                        " " +
                        (selectedOption?.lastName || "") +
                        " " +
                        "(" +
                        selectedOption?.personnelNumber +
                        ")"
                    }}
                  </ng-template>
                  <ng-template pTemplate="item" let-item>
                    {{
                      (item?.firstName || "") +
                        " " +
                        (item?.lastName || "") +
                        " " +
                        "(" +
                        item?.personnelNumber +
                        ")"
                    }}
                  </ng-template>
                </p-select>
              </div>
            </div>

            <div
              class="col-3 fixed-width mb-2"
              *ngIf="showBrandingConsultantWhoSupportsMeDropDown">
              <div class="form-group has-float-label">
                <label class="form-label" for="bcSelectedId"
                  >BAC / BAS<span></span
                ></label>
                <p-select
                  [(ngModel)]="bcSelectedId"
                  (onChange)="bcSelected()"
                  [disabled]="disableDropDown"
                  [options]="bcList"
                  [filter]="true"
                  [showClear]="true"
                  [filterBy]="'firstName,lastName,personnelNumber'"
                  [emptyFilterMessage]="'No records found'"
                  optionValue="personnelNumber"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="35">
                  <ng-template #selectedItem let-selectedOption>
                    {{
                      (selectedOption?.firstName || "") +
                        " " +
                        (selectedOption?.lastName || "") +
                        " " +
                        "(" +
                        selectedOption?.personnelNumber +
                        ")"
                    }}
                  </ng-template>
                  <ng-template let-item #item>
                    {{
                      (item?.firstName || "") +
                        " " +
                        (item?.lastName || "") +
                        " " +
                        "(" +
                        item?.personnelNumber +
                        ")"
                    }}
                  </ng-template>
                  <!-- <ng-option *ngFor="let com of bcList" [value]="com.personnelNumber">
              {{
                (com?.firstName || '') +
                  ' ' +
                  (com?.lastName || '') +
                  ' ' +
                  '(' +
                  com?.personnelNumber +
                  ')'
              }}
            </ng-option> -->
                </p-select>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!fromManager">
            <div class="col-3 fixed-width mb-2">
              <div class="form-group has-float-label">
                <label class="form-label" for="selectedDateRange"
                  >Date Range</label
                >
                <span
                  ><p-select
                    #filter
                    [(ngModel)]="selectedDateRange"
                    (click)="onDateRangeSelection(selectedDateRange)"
                    [options]="dateRange"
                    optionValue="name"
                    optionLabel="name">
                  </p-select
                ></span>
              </div>
            </div>
            <div class="col-3 fixed-widthmb-2">
              <div class="form-group has-float-label">
                <label class="form-label col-12" for="fromDate"
                  >From Date</label
                >
                <p-datePicker
                  jniAutoCompleteBlocker
                  name="fromDate"
                  id="fromDate"
                  [(ngModel)]="fromDate"
                  (focusout)="onFromDateSelection($event)"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  dateFormat="mm/dd/yy"
                  dataType="string" />
              </div>
            </div>
            <div class="col-3 fixed-width mb-2">
              <div class="form-group has-float-label">
                <label class="form-label col-12" for="toDate">To Date</label>
                <p-datePicker
                  jniAutoCompleteBlocker
                  name="toDate"
                  id="toDate"
                  [(ngModel)]="toDate"
                  (focusout)="onToDateSelection($event)"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  dateFormat="mm/dd/yy"
                  dataType="string" />
              </div>
            </div>
          </ng-container>

          <div
            class="col-3 fixed-width-button d-flex align-items-center"
            *ngIf="!showHeading">
            <div class="form-group has-float-label d-flex gap-2">
              <p-button
                label="Filter"
                (click)="onSubmit()"
                [disabled]="!bcSelectedId && showBrandingConsultantDropDown" />

              <!-- <button
                class="btn btn btn-primary"
                type="submit"
                (click)="onSubmit()"
                [disabled]="!bcSelectedId && showBrandingConsultantDropDown">
                Filter
              </button> -->

              <!-- <button
          *ngIf="isManager"
          class="btn btn btn-primary me-3"
          type="submit"
          (click)="removeFilter()"
          >
          Remove Filter
        </button> -->

              <p-button
                label="Remove Filter"
                *ngIf="showRemoveFilter"
                (click)="removeFilterButton()" />
            </div>
          </div>

          <div class="row mt-1" *ngIf="showHeading">
            <div class="col-3 form-group has-float-label">
              <p-button
                label="Filter"
                [disabled]="!bcSelectedId && showBrandingConsultantDropDown"
                (click)="onSubmit()" />
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>
